import { CATEGORY_TEMPLATES_WITH_IMG } from 'Components/Carousel/CarouselUtils'
import { atom } from 'recoil'

export const campaignState = atom({
  key: 'CampaignState',
  default: {
    isDirty: false,
    Id: 0,
    Name: '',
    nameIsDiry: false,
    IdSource: undefined,
    idSouceIsDirty: false,
    IdList: undefined,
    ShowNumberOfContents: 5,
    showNumberOfContentsIsDirty: false,
    CheckNumberOfNewContents: 1,
    CheckFrequency: '', // struttura: 'h m * * d', con d = 0,1,2,3,4,5,6
    CheckFrequencyType: undefined,
    Status: undefined,
    Enabled: false,
    CreationDate: '',
    UpdateDate: '',
    Timezone: '',
    EmailOptions: {
      Subject: '',
      subjectIsDirty: false,
      SubjectType: 1,
      PreHeader: '',
      PreHeaderType: undefined,
      IdMessage: undefined,
      IncludeGroups: [],
      ExcludeGroups: [],
      ApplyFilter: [],
      ApplyFilterCondition: false, // true: filtri in OR, false: filtri in AND
      IdContentEndpoint: undefined,
      SenderName: '',
      SenderEmail: '',
      ReplyTo: '',
      IdTemplate: undefined,
      TemplateType: CATEGORY_TEMPLATES_WITH_IMG
    }
  }
})
